import { detect } from 'detect-browser';

const browser = detect();
const dragImagesFileExtension = browser && (browser.name === 'chrome' || browser.name === 'firefox') ? 'svg' : 'png';

export default {
    APP_FATAL_CRASH: 'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/canvas/fatal-crash-error.png',
    BANANATAG_LOGO_TRANSPARENT: 'https://app-data-legacy.bananatag.com/pikasso/assets/logo/btag-logo-banana.svg',
    SBT_LOGO: 'https://app-data-legacy.bananatag.com/pikasso/assets/logo/sbt-logo.png',
    BROWSER_WIDTH_SMALL: 'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/canvas/browser-too-small.png',
    BROWSER_HEIGHT_SMALL: 'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/canvas/browser-too-small.png',
    BROWSER_SMALL_PIKASSO:
        'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/canvas/browser-too-small-pikasso.png',
    BLOCK_HOVER_IMAGE: `https://app-data-legacy.bananatag.com/pikasso/assets/placeholders/block-default-drag.${dragImagesFileExtension}`,
    FOLDER_EMPTY_STATE: 'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/canvas/folder-emptystate.svg',
    EMPTY_FOLDER_ARROW_UP:
        'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/canvas/empty-folder-arrow-up.svg',
    CONTENT_LIBRARY_LOADER: 'https://app-data-legacy.bananatag.com/pikasso/assets/loader/banana-loader.gif',
    STAFFBASE: {
        NO_RESULTS: 'https://app-data-legacy.bananatag.com/pikasso/assets/staffbase/No_Search_Results.png',
        NO_POSTS: 'https://app-data-legacy.bananatag.com/pikasso/assets/staffbase/No_Posts.png',
        NULL_IMAGE: 'https://app-data-legacy.bananatag.com/pikasso/assets/staffbase/Null_Image_Pattern.png',
        LOGO: 'https://app-data-legacy.bananatag.com/pikasso/assets/staffbase/Logo.png',
    },
    PLAY_BUTTON: {
        BLACK: 'https://storage-thumbnails.bananatag.com/play-black.png',
        WHITE: 'https://storage-thumbnails.bananatag.com/play-white.png',
    },
    PLACEHOLDERS: {
        IMAGE_UPLOAD: 'https://app-data-legacy.bananatag.com/pikasso/assets/placeholders/image.png',
        VIDEO_UPLOAD: 'https://app-data-legacy.bananatag.com/pikasso/assets/placeholders/video.png',
    },
    PANEL: {
        EDIT_HTML_ARROW: 'https://app-data-legacy.bananatag.com/pikasso/assets/panel/edit-html-arrow.svg',
        EDIT_HTML_ICON: 'https://app-data-legacy.bananatag.com/pikasso/assets/panel/edit-html-code-icon.png',
    },
    ICONS: {
        ALT_TEXT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/icon-alt-text.svg',
        BUTTON_TEXT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/icon-button-text.svg',
        BOLD: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/bold-solid.svg',
        ITALIC: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/italic-solid.svg',
        LINK: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/link-solid.svg',
        LIST_BULLETED: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/list-ul-regular.svg',
        LIST_NUMBERED: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/list-ol-solid.svg',
        SUBSCRIPT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/inline-editor/subscript.png',
        SUPERSCRIPT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/inline-editor/superscript.png',
        UNDERLINE: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/underline-custom.svg',
        COPY: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/content_copy.svg',
        COPY_BLACK: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/content_copy_black.svg',
        LOCK_OUTLINE: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/outline-lock.svg',
        ARROW_RIGHT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/arrow-right.svg',
        CHEVRON_RIGHT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/arrow_forward_ios.svg',
        GRAB_CURSOR: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/grab.cur',
        FILESIZE_WARNING: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/filesize_warning.svg',
        HTML_EDIT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/HTML.svg',
        MENU_ICON: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/TOC_menu.svg',
        LIST_ICON: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/TOC_list.svg',
        CLEAR: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/remove-format-solid.svg',
        ARROW_DOWN: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/caret-down-solid.svg',
        ELLIPSIS: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/toolbar/ellipsis-v-solid.svg',
        LINK_TEXT: 'https://app-data-legacy.bananatag.com/pikasso/assets/icons/text-solid.svg',
    },
    COLLAPSED_ICONS: {
        BLOCK_LAYOUTS: {
            DEFAULT: 'https://app-data-legacy.bananatag.com/pikasso/assets/collapsed-icons/block-layouts-default.svg',
            HIGHLIGHTED:
                'https://app-data-legacy.bananatag.com/pikasso/assets/collapsed-icons/block-layouts-highlighted.svg',
        },
        ELEMENTS: {
            DEFAULT: 'https://app-data-legacy.bananatag.com/pikasso/assets/collapsed-icons/elements-default.svg',
            HIGHLIGHTED:
                'https://app-data-legacy.bananatag.com/pikasso/assets/collapsed-icons/elements-highlighted.svg',
        },
        QUICK_BLOCKS: {
            DEFAULT: 'https://app-data-legacy.bananatag.com/pikasso/assets/collapsed-icons/quick-blocks-default.svg',
            HIGHLIGHTED:
                'https://app-data-legacy.bananatag.com/pikasso/assets/collapsed-icons/quick-blocks-highlighted.svg',
        },
    },
    DROP_ZONE: {
        ELEMENT: {
            HIGHLIGHTED: `${process.env.PUBLIC_URL}/assets/drop-zone/element/highlighted.png`,
            NOT_HIGHLIGHTED: `${process.env.PUBLIC_URL}/assets/drop-zone/element/not-highlighted.png`,
        },
        BLOCK: {
            HIGHLIGHTED: `${process.env.PUBLIC_URL}/assets/drop-zone/block/highlighted.png`,
            NOT_HIGHLIGHTED: `${process.env.PUBLIC_URL}/assets/drop-zone/block/not-highlighted.png`,
        },
        CANVAS: {
            HIGHLIGHTED: `${process.env.PUBLIC_URL}/assets/drop-zone/canvas/highlighted.png`,
            NOT_HIGHLIGHTED: `${process.env.PUBLIC_URL}/assets/drop-zone/canvas/not-highlighted.png`,
        },
        IMPORT: {
            WHISKERS: 'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/import/whiskers.png',
            ARROW: 'https://app-data-legacy.bananatag.com/pikasso/assets/drop-zone/import/arrow.png',
        },
    },
    BLOCK_LAYOUTS_IMAGE_SOURCES: (name, isDragging) =>
        `https://app-data-legacy.bananatag.com/pikasso/assets/block-layouts/${name}${isDragging ? '-drag' : ''}.${
            isDragging ? dragImagesFileExtension : 'svg'
        }`,
    ELEMENT_ICONS: (type, isDragging) => `https://app-data-legacy.bananatag.com/pikasso/assets/element-collection/${type.toLowerCase()}${
        isDragging ? '-drag' : ''
    }.${isDragging ? dragImagesFileExtension : 'svg'}`,
    BLOCK_THUMBNAILS: (title, isDragging) =>
        `https://app-data-legacy.bananatag.com/pikasso/assets/block-thumbnails/${title}${isDragging ? '-drag' : ''}.${
            isDragging ? dragImagesFileExtension : 'svg'
        }`,
};
